import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=28a35298"
import script from "./ShopList.vue?vue&type=script&lang=js"
export * from "./ShopList.vue?vue&type=script&lang=js"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=28a35298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports